<template>
  <div class="bottom-container">
  <!-- <div class="bottom-container"> -->
    <div class="button-container"  id="buttonContainer">
      <el-button
        type="primary"
        v-preventReClick
        v-if="buildNew"
        @click="buildNewOne"
      >
        保存
      </el-button>
      <el-button 
        type="primary"
        v-preventReClick
        v-if="processStatus && processDetail.process.isEndpoint && processDetail.button.find(b => b.buttonKey == 'wf_pass')"
        @click="goNext"
      >办结</el-button>

      <!-- 核定额度按钮 保理尽调用 2022/08/01 -->
      <el-button 
        type="primary"
        v-preventReClick
        v-if="showCheckButton"
        @click="changeCredit"
      >核定额度</el-button>

      <el-button
        v-if="processStatus && !processDetail.process.isEndpoint && processDetail.button.find(b => b.buttonKey == 'wf_pass')"
        type="primary"
        v-preventReClick
        @click="goNext"
      >转交下一步</el-button>
      <el-button
        v-if="processStatus && processDetail.button.find(b => b.buttonKey == 'wf_transfer')"
        type="primary"
        v-preventReClick
        @click="toPerson"
        plain
      >转他人处理</el-button>
      <!-- 发起流程 -->
      <el-button v-if="!isStartedProcess && showStartProcess" type="primary" plain @click="startProcess" v-preventReClick>{{startProcessName}}</el-button>
      <!-- 保存项目详情并保存流程 -->
      <el-button v-if="processStatus" type="primary" plain @click="taskFlowSave" v-preventReClick>保存流程</el-button>
      <!-- 普通保存, 
      
           1.非新建项目时 
           2.当前详情不可跳转编辑页时
           3.当前并非todo时
      -->
      <el-button 
        v-if="!buildNew
              && !goEdit
              && (!processStatus || allowEdit)
              && (auditState =='0' || allowEdit)"
        type="primary"
        plain 
        v-preventReClick
        @click="detailSave"
      >保存</el-button>

      <el-button
        type="primary"
        v-if="goEdit"
        v-preventReClick
        @click="goEditPage"
      >
        编辑
      </el-button>

       <!-- v-if="processDetail.button.find(b => b.buttonKey == 'wf_print')" -->
      <el-button
        v-if="isStartedProcess && !batchStatus && (processDetail.form && processDetail.form.printFormKey.trim() != '')"
        type="info"
        plain
        v-preventReClick
        @click="printForm"
      >打印</el-button>
      <el-button
        type="danger"
        @click="rollBack"
        plain
        v-preventReClick
        v-if="processStatus && processDetail.button.find(b => b.buttonKey == 'wf_reject')"
      >退回</el-button>
      <el-button
        type="danger"
        @click="cancelProcess"
        plain
        v-preventReClick
        v-if="processStatus && processDetail.button.find(b => b.buttonKey == 'wf_terminate')"
      >终止</el-button>
    </div>

    <el-dialog
      title="转他人处理"
      :visible.sync="dialogVisible"
      :destroy-on-close='true'
      :modal-append-to-body="true"
      :append-to-body="true"
      width="40%"
     >
      <template>
        <avue-form
          :option="changeFormConfig"
          ref="changePersonForm"
          v-model="changeForm"
          @submit="handleSubmit"
        >
        </avue-form>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="taskToAnother">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="nodeVisible"
      :modal-append-to-body="false"         
      title="选择回退节点">
      <RollBack
        :nodeList="nodeList"
        @rollBack="handleRollBack"
        @cancelDialog="handleCancelDialog"
      />
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="选择接受人员"
      :visible.sync="showSelectPeople"
      :modal-append-to-body="false"
      width="38%"
    >
      <el-form ref="form" :model="selectPeopleData" label-width="120px">
        <template v-for="(item, index) in selectPeopleList">
          <el-form-item :key="index" :label="`${item.taskDefName}:`" prop="">
            <el-select
              v-model="selectPeopleData[index].manager"
              size="small"
            >
              <el-option
                v-for="(p, i) in item.personList"
                :key="i"
                :label="p"
                :value="p">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-form>

      <div class="bottom-content">
        <el-button @click="showSelectPeople = false" size="small">取消</el-button>
        <el-button type="primary" @click="selectPeopleFlowNext" size="small">确定</el-button>
      </div>
    </el-dialog>

    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />
  </div>
</template>
<script>
import SelectPerson from "@/components/SelectPersonnel/person";
import RollBack from '@/views/plugin/workflow/components/wf-rollBack'
import WorkFlow from "@/mixins/workFlow";
import { mapGetters } from "vuex";
import { getSsoToken, getNextTaskInfo } from "@/api/workFlow/workFlow";
import { getProcessmodelsettingList } from "@/api/finance/travelExpense";

export default {
  name: 'bottomLine',
  mixins: [WorkFlow],
  data() {
    return {
      nodeList: [],
      nodeVisible: false,
      dialogVisible: false,
      showSelectPeople: false,
      selectPeopleList: [],
      selectPeopleData: [],
      checkUserList: [],
      changeForm: {},
      showBottom: true,
      changeFormConfig: {
        emptyBtn: false,
        submitBtn: false,
        disabled: false,
        column: [
          {
            label: '接收人员',
            prop: 'handlerName',
            click: this.selectPersonClick,
            span: 24,
            rules: [
              {
                required: true,
                message: "请选择接收人员",
                trigger: "change",
              },
            ]            
          },{
            label: '备注信息',
            span: 24,
            prop: 'remark',
            type: 'textarea'
          }
        ]
      }
    }
  },
  props: {
    buildNew: {
      type: Boolean,
      default: false
    },
    goEdit: {
      type: Boolean,
      default: false
    },    
    processDetail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // opinionArray: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   }
    // },
    // 是否可以编辑
    auditState: {
      type: String,
      default: ''
    },
    // 是否开启流程
    isStartedProcess: {
      type: Boolean,
      default: false
    },
    // 是否显示核定额度
    showCheckButton: {
      type: Boolean,
      default: false
    },
    // 发起流程名字自定义
    startProcessName: {
      type: String,
      default: '发起流程'
    },
    // 批量审批页面状态
    batchStatus: {
      type: Boolean,
      default: false
    },
    // 是否隐藏发起流程按钮
    showStartProcess: {
      type: Boolean,
      default: true
    },
    // 财务页面判断当前节点是否财务审批用
    finalParam: {
      type: Object,
      default: () => {
        return {processKey: [], nodeName: ''}
      },
      required: false
    }
  },
  computed: {
    ...mapGetters(["workFlowState", "workFlowData", 'flowData']),
    buttonNum() {
      if(document.getElementById('buttonContainer')){
        return document.getElementById('buttonContainer').getElementsByTagName('button').length
      }else {
        return 0
      }
    },
    allowEdit() {
      return this.workFlowState.isFirstFlowPermission
    },
    processStatus() {
      if(this.processDetail && this.processDetail.process) {
        return this.processDetail.process.status == 'todo' ? true: false
      } else {
        return false
      }
    },
    taskId() {
      if(this.processDetail && this.processDetail.process) {
       return this.processDetail.process.taskId
      }
    }
  },
  components: {
    RollBack,
    SelectPerson
  },
  async mounted() {
    // this.taskId = this.processDetail.process.taskId
    // this.nodeList = await this.queryNodeList(this.taskId)
  },
  methods: {
    goEditPage() {
      this.$emit('goEdit')
    },
    changeCredit() {
      this.$emit('changeCredit')
    },
    buildNewOne() {
      this.$emit('buildNewOne')
    },
    async startProcess() {
      this.$emit('startProcess')
    },

    detailSave() {
      this.$emit('saveProject')
    },
    // 回退
    async rollBack() {
      // 查询可回退节点
      this.nodeList = await this.queryBackStepList(this.taskId)
      this.nodeVisible = true
    },

    // 打印表单
    async printForm() {
       //获取公司名称   财务中心板块使用
       let companyName=''
       let processKey = this.processDetail.process.processDefinitionKey
       let financeProcess = await getProcessmodelsettingList({processKey})
       

      // this.$emit('openPrintForm')
      let printFormKey = this.processDetail.form.printFormKey

      if(financeProcess.data.code==200&&financeProcess.data.data.records.length>0){
        companyName=financeProcess.data.data.records[0]["companyName"]
        
       } 

      // 获取ssoToken
      let res = await getSsoToken({})
      let ssoToken = res.data.data.ssoToken
      let frontUrl = res.data.data.foreignUrl

      let redirectId = this.$route.params.id
      let flowableId = this.processDetail.process.processInstanceId
      // 跳转打印地址 http://192.168.12.189:80
      let openUrl = ''
      if(redirectId.indexOf('-') > 0) {
        openUrl = `http://${frontUrl}/webroot/decision/view/report?viewlet=${printFormKey}&flowableId=${flowableId}&ssoToken=${ssoToken}`
      }else {
        openUrl = `http://${frontUrl}/webroot/decision/view/report?viewlet=${printFormKey}&id=${redirectId}&ssoToken=${ssoToken}`
      }
      // let openUrl = `${window.location.origin}/webroot/decision/view/report?viewlet=${printFormKey}&id=${redirectId}&ssoToken=${ssoToken}`
      if(companyName){
        openUrl+`&companyName=${companyName}`
      }
      window.open(openUrl)
    },

    taskFlowSave() {
      // 保存流程草稿
      this.$emit('saveTask')
    },

    async handleRollBack(nodeId, comment) {
      // 回退
      let res = await this.taskFlowBack(this.taskId, nodeId, comment)
      this.$emit('refreshData')
      this.handleCancelDialog()
    },

    handleCancelDialog() {
      this.nodeVisible = false
    },

    resetForm() {
      if(this.$refs.changePersonForm){
        this.$refs.changePersonForm.resetForm()
        this.$refs.changePersonForm.clearValidate()
      }
    },
    handleClose() {
      this.dialogVisible = false
    },

    async goNext() {
      const self = this;
      const { process } = this.processDetail;

      if (process.doSelect && process.doSelect == 1) {
        // 弹出人员选择框
        this.selectPeopleData = [];
        const res = await getNextTaskInfo({ taskId: process.taskId });
        this.selectPeopleList = res.data.data.options;
        this.selectPeopleList.forEach(item => {
          self.selectPeopleData.push({ manager: '', taskDefId: item.taskDefId, isSelected: true });
        });
        this.showSelectPeople = true;
      } else {
        const { finalParam } = this;
        const { processDefinitionKey, isEndpoint } = process;
        const { flowData } = this.$store.state.user;
        const presentFlow = flowData[flowData.length - 1].historyActivityName;

        if (finalParam.processKey.length > 0 && finalParam.processKey.includes(processDefinitionKey) && finalParam.nodeName === presentFlow) {
          // 显示是否董事长选择弹窗
          this.$emit('showChairmanAudit');
        } else {
          const msg = isEndpoint ? '是否办结当前流程？' : '是否转交下一步？';
          this.$confirm(msg, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            closeOnClickModal: true,
            closeOnPressEscape: true,
            closeOnHashChange: true
          }).then(() => {
            self.$emit('flowNext');
          }).catch(err => {});
        }
      }
    },


    selectPeopleFlowNext() {
      let formComplete = true
      this.selectPeopleData.map(item => {
        if(item.manager == '') {
          formComplete = false
        }
      })
      if(formComplete) {
        this.$emit("flowNext", this.selectPeopleData)
      }else {
        this.$message.warning('请先选择人员再提交')
      }
    },

    cancelProcess() {
      let self = this
      this.$confirm("是否确定取消流程？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async() => {
        // 传入taskId
        let res = await self.taskFlowStop(this.processDetail.process.taskId)
        self.$emit('refreshData')
      }).catch(err=> {
        
      });
    },

    toPerson() {
      this.resetForm()
      this.checkUserList = []
      this.dialogVisible = true
    },

    // 任务转他人处理
    taskToAnother() {
      let self = this
      // 校验changePersonForm是否填写完全
      this.$refs.changePersonForm.validate(async(valid) => {
        if (valid) {
          // 发送请求
          await self.taskFlowTransfer({
            assignee: self.changeForm.handlerId,
            taskId: self.processDetail.process.taskId,
            comment: self.changeForm.remark
          })
          this.dialogVisible = false
          self.$emit('refreshData')
        } else {
          self.$message({
            message: "请填写完整信息后确认提交",
            type: "warning"
          });
        }
      });
    },
    closeSelectDialog() {
      this.showSelectPeople = false
    },

    selectPersonClick() {
      this.$refs.selectperson.showmode();
    },
    
    setPeople(val) {
      this.checkUserList = val;
      let people = val.map((item) => {
        return item.realName;
      });
      let ids = val.map((item) => {
        return item.id;
      });
      this.changeForm.handlerId = ids.join(',')
      this.changeForm.handlerName = people.join(',')
    },
  }
}
</script>
<style lang="scss" scoped>
.bottom-container{
  width: 100%;
  height: 70px;
  position: fixed;
  // z-index: 1000;
  bottom: 0px;
  left: 0px;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0 , 0.05);
  .bottom-content{
    display: flex;
    justify-content: flex-end;
    padding-bottom: 15px;
    padding-top: 15px;
    border-top: 1px solid #f1f1f1;
  }
  .button-container{
    width: 78%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;

  }
  /deep/ .el-dialog{
    border-radius: 5px;
  }
  /deep/ .el-dialog__body {
    padding: 30px 10% 0px !important;
    border-bottom: 1px solid rgb(245, 245, 245);
    .button-container{ 
       margin-bottom: 10px;
    }
  }  
  /deep/ .el-dialog__header{
    border-radius: 5px 5px 0px 0px;
    // background-color: rgb(245, 245, 245);
    color: #333;
  }
}
</style>